/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserData } from './UserData';
import {
    UserDataFromJSON,
    UserDataFromJSONTyped,
    UserDataToJSON,
    UserDataToJSONTyped,
} from './UserData';
import type { ProjectUserOutputRole } from './ProjectUserOutputRole';
import {
    ProjectUserOutputRoleFromJSON,
    ProjectUserOutputRoleFromJSONTyped,
    ProjectUserOutputRoleToJSON,
    ProjectUserOutputRoleToJSONTyped,
} from './ProjectUserOutputRole';

/**
 * 
 * @export
 * @interface ProjectUserOutput
 */
export interface ProjectUserOutput {
    /**
     * 
     * @type {UserData}
     * @memberof ProjectUserOutput
     */
    user?: UserData;
    /**
     * 
     * @type {ProjectUserOutputRole}
     * @memberof ProjectUserOutput
     */
    role?: ProjectUserOutputRole | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectUserOutput
     */
    isOwner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectUserOutput
     */
    lastInteraction?: string;
}

/**
 * Check if a given object implements the ProjectUserOutput interface.
 */
export function instanceOfProjectUserOutput(value: object): value is ProjectUserOutput {
    return true;
}

export function ProjectUserOutputFromJSON(json: any): ProjectUserOutput {
    return ProjectUserOutputFromJSONTyped(json, false);
}

export function ProjectUserOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUserOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : UserDataFromJSON(json['user']),
        'role': json['role'] == null ? undefined : ProjectUserOutputRoleFromJSON(json['role']),
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'lastInteraction': json['lastInteraction'] == null ? undefined : json['lastInteraction'],
    };
}

export function ProjectUserOutputToJSON(json: any): ProjectUserOutput {
    return ProjectUserOutputToJSONTyped(json, false);
}

export function ProjectUserOutputToJSONTyped(value?: ProjectUserOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserDataToJSON(value['user']),
        'role': ProjectUserOutputRoleToJSON(value['role']),
        'isOwner': value['isOwner'],
        'lastInteraction': value['lastInteraction'],
    };
}

